import { Radio as Radio_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Radio = forwardRef(({ ...props }, ref) => {
    return <Radio_ ref={ref} {...props}>{props?.children}</Radio_>
});

import { RadioGroup as RadioGroup_ } from "@chakra-ui/react";
export const RadioGroup = forwardRef(({ ...props }, ref) => {
    return <RadioGroup_ ref={ref} {...props}>{props?.children}</RadioGroup_>
});